import ApiClient from '../ApiClient';



const LinkedInService = {
  async post({ message, imageUrl, accessToken }) {
    const payload = { message, imageUrl, accessToken };
    const resp = await ApiClient.post('/SocialAuth/linkedin/post', payload);
    return resp.data;
  },

  async getOrganizations() {
    const resp = await ApiClient.get('/SocialAuth/linkedin/organizations');
    return resp.data;
  }
};

export default LinkedInService;
